import { townColorHex as hex } from './townPropTemplates';
import type { TownPropPalette } from './townPropTemplates';

/** 44×58 wall fixture. The solid plate at1,6,4×20 is its catalog mount patch. */
export function buildBracketLanternBody(p: TownPropPalette): string {
  const iron = hex(p.iron), edge = hex(p.woodEdge);
  return `<g data-part="wall-plate">
    <rect x="1" y="6" width="4" height="20" fill="${iron}" />
    <circle cx="3" cy="9" r="0.8" fill="${edge}" /><circle cx="3" cy="23" r="0.8" fill="${edge}" />
  </g>
  <path data-part="bracket-arm" d="M5 15H13Q20 15 20 9Q20 4 27 4Q34 4 34 11V18"
    fill="none" stroke="${iron}" stroke-width="3" />
  <path d="M6 13H13Q18 13 18 9" fill="none" stroke="${edge}" stroke-width="0.7" opacity="0.7" />
  <g data-part="bracket-cage">
    <path d="M24 24L29 18H39L43 24Z" fill="${iron}" />
    <rect x="27" y="24" width="14" height="24" fill="${hex(p.primary)}" />
    <rect x="31" y="27" width="6" height="16" fill="${hex(p.glassCore)}" opacity="0.6" />
    <path d="M27 24V48H41V24 M34 24V48 M27 36H41" fill="none" stroke="${iron}" stroke-width="2" />
    <path d="M25 49H43L38 54H30Z" fill="${iron}" />
    <path d="M28 50H40" stroke="${edge}" stroke-width="1" />
    <rect x="32" y="54" width="4" height="4" fill="${iron}" />
  </g>`;
}

function signBoard(p: TownPropPalette): string {
  return `<g data-part="sign-board">
    <path d="M8 15L64 14L63 40L9 39Z" fill="${hex(p.wood)}" />
    <path d="M11 18L61 17L60 37L12 36Z" fill="${hex(p.primary)}" />
    <path d="M14 20H27 M46 20H58 M14 34H26 M48 34H58" stroke="${hex(p.woodEdge)}" stroke-width="0.8" opacity="0.6" />
    <path d="M26 22V25L23 28V34H32V28L29 25V22Z" fill="${hex(p.stone)}" />
    <path d="M26 21H29 M24 30H31" stroke="${hex(p.iron)}" stroke-width="1.5" />
    <path d="M38 33Q35 28 42 26Q49 24 54 29L53 33Z" fill="${hex(p.woodEdge)}" />
    <path d="M41 27L43 30 M46 26L48 30 M50 28L52 30" stroke="${hex(p.wood)}" stroke-width="1" />
    <circle cx="13" cy="19" r="1" fill="${hex(p.iron)}" /><circle cx="59" cy="19" r="1" fill="${hex(p.iron)}" />
  </g>`;
}

/** 72×44 ceiling sign. Ink is confined between the existing canopy's diagonal braces. */
export function buildShopSignBody(p: TownPropPalette): string {
  return `<g data-part="sign-hangers" fill="none" stroke="${hex(p.iron)}" stroke-width="1.8">
    <path d="M22 0V17 M50 0V17" />
    <path d="M20 3H24 M48 3H52 M20 12H24 M48 12H52" stroke="${hex(p.woodEdge)}" stroke-width="0.7" />
  </g>${signBoard(p)}`;
}

/** Safe unnamed sign fallback is freestanding; only the named catalog sign can claim ceiling support. */
export function buildGroundSignBody(p: TownPropPalette): string {
  return `<rect x="34" y="26" width="4" height="18" fill="${hex(p.wood)}" />
    <rect x="26" y="42" width="20" height="2" fill="${hex(p.iron)}" />
    <g transform="translate(0 -6)">${signBoard(p)}</g>`;
}
